export default __webpack_public_path__ + "static/media/049-worker.9f8ee6a7.svg";